import React    from 'react';
import { withRouter } from 'react-router';
import CustomLink from 'components/Link/Link.react';


const LinkWithBack = (props) => {

  const { params, location, router, routes, to, ...rest } = props;

  const toBack = {
    pathname: location.pathname,
    params,
  }

  const toModified = typeof to === 'string'
    ? { pathname: to }
    : to

  toModified.state = {
    ...(location.state || {}),
    backURL: toBack,
  }

  return (
    <CustomLink {...rest} to={toModified} />
  );
};

export default withRouter(LinkWithBack);